import Spinner from '../../Spinners/Spinner';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface POSToolbarButtonProps {
  icon: string;

  onClick?: () => void;

  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark';

  title?: string;

  disabled?: boolean;

  className?: string;

  loading?: boolean;
}

const POSToolbarButton: React.FC<POSToolbarButtonProps> = ({
  icon,

  onClick,

  variant = 'secondary',

  title,

  disabled = false,

  className = '',

  loading = false,
}) => {
  // =====================================================
  // 🎨 Variants
  // =====================================================
  const variants = {
    primary: `
    bg-primary
    text-white
    hover:opacity-90
  `,

    secondary: `
    bg-gray
    text-body
    border
    border-stroke
    hover:border-primary
    hover:text-primary

    dark:bg-meta-4
    dark:border-strokedark
    dark:text-bodydark1
  `,

    success: `
    bg-success
    text-white
    hover:opacity-90
  `,

    danger: `
    bg-danger
    text-white
    hover:opacity-90
  `,

    warning: `
    bg-warning
    text-white
    hover:opacity-90
  `,

    info: `
    bg-meta-10
    text-white
    hover:opacity-90
  `,

    dark: `
    bg-boxdark
    text-white
    hover:opacity-90
  `,
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`
      inline-flex

      h-[43px]
      w-[43px]

      items-center
      justify-center

      rounded-xl

      shadow-1

      transition-all
      duration-200

      hover:shadow-2

      disabled:cursor-not-allowed
      disabled:opacity-50

      ${variants[variant]}
      ${className}
    `}
    >
      {loading ? (
        <Spinner size={18} color="white" />
      ) : (
        <SvgIcon name={icon} className="h-5 w-5" />
      )}
    </button>
  );
};

export default POSToolbarButton;
